// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconSaved: React.FC = () => {
    return (
        <svg width="11px" height="11px" viewBox="0 0 11 11" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="Page-1" stroke="none" strokeWidth="1" fill="currentColor" fill-rule="evenodd">
                <g id="save" transform="translate(0.000000, 0.250000)" fill-rule="nonzero">
                    <path
                        d="M10.1507814,2.27578139 L8.18437529,0.309375286 C8.02265596,0.148125172 7.66640639,0 7.40859389,0 L1.5,0 C0.671484232,0 0,0.671484232 0,1.5 L0,9 C0,9.82851577 0.671484232,10.5 1.5,10.5 L9,10.5 C9.82851577,10.5 10.5,9.82851577 10.5,9 L10.5,3.09140611 C10.5,2.83359361 10.352344,2.47734404 10.1507814,2.27578139 Z M5.25,9 C4.42171884,9 3.75,8.32828116 3.75,7.5 C3.75,6.67171884 4.42171884,6 5.25,6 C6.07828116,6 6.75,6.67171884 6.75,7.5 C6.75,8.32828116 6.07734346,9 5.25,9 Z M7.5,4.125 C7.5,4.33125007 7.33124971,4.5 7.125,4.5 L1.875,4.5 C1.66781259,4.5 1.5,4.33125007 1.5,4.125 L1.5,1.875 C1.5,1.66875029 1.66781259,1.5 1.875,1.5 L7.125,1.5 C7.33124971,1.5 7.5,1.66875029 7.5,1.875 L7.5,4.125 Z"
                        id="Shape"
                    ></path>
                </g>
            </g>
        </svg>
    );
};

export default React.memo(IconSaved);
